// import moment from "jalali-moment";

export const GetToDay = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let now_today = yyyy + '-' + mm + '-' + dd;
    return now_today
}
